import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { ITask2ReportAvailableItems, ITask2ReportContainer, ITask2ReportWidget } from '../fi-task-v2-report';
import { FiTaskReportType } from '../fi-task-v2-report-enums';
import { FiTaskV2ReportDataService } from '../services/fi-task-v2-report-data.service';
import { NewWidgetDialogBaseDirective } from '@fi-shared/fi-report-widget/new-report-widget-dialog/new-widget-dialog-base';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';

@Component({
    selector: 'fi-new-widget-dialog',
    templateUrl: './fi-new-widget-dialog.component.html',
    styleUrls: ['./fi-new-widget-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-new-widget-dialog' },
    standalone: false,
})
export class FiNewWidgetDialogComponent extends NewWidgetDialogBaseDirective<FiTaskReportType, ITask2ReportWidget> {
    private readonly fiTaskV2ReportDataService = inject(FiTaskV2ReportDataService);
    protected reportContainer: ITask2ReportContainer = null;

    protected createCurrentReportWidget(): void {
        if (isNullOrUndefined(this.reportContainer)) {
            this.setReportData();
        } else {
            this.setCurrentReportWidgetData();
        }
    }

    private setReportData(): void {
        this.loading.set(true);
        this.fiTaskV2ReportDataService.getReportContainer().then((reportContainer) => {
            this.reportContainer = reportContainer;
            this.setCurrentReportWidgetData();
            this.loading.set(false);
        });
    }

    private setCurrentReportWidgetData() {
        const newReportWidget: ITask2ReportWidget = {
            Name: '',
            Description: '',
            ReportType: this.currentReportWidgetType,
            SortIndex: this.reportContainer.ReportWidgets.length,
            Settings: {
                CurrentFilterGuid: '',
                Filters: [],
            },
        };
        this.reportWidget = { ...newReportWidget };
    }

    protected getCanCloseWithoutConfirmation(): boolean {
        return isNullOrUndefined(this.currentReportWidgetType);
    }
}
